import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex flex-1 items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "mt-2 space-y-2 sm:flex sm:justify-between sm:space-y-0" }
const _hoisted_8 = { class: "space-y-2 sm:flex sm:space-x-4 sm:space-y-0" }
const _hoisted_9 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_10 = { class: "flex flex-wrap gap-2 text-sm text-gray-500" }

import UiAuditInfo from '@/components/UiAuditInfo.vue';
import { Permission, ScheduleWeekday, WorkScheduleModel } from '@/types';
import { CheckCircleIcon, PencilAltIcon, XCircleIcon } from '@heroicons/vue/outline';
import { CalendarIcon, ClockIcon } from '@heroicons/vue/solid';
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkScheduleListItem',
  props: {
    modelValue: {
        type: Object as PropType<WorkScheduleModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const weekdays: ScheduleWeekday[] = [
    ScheduleWeekday.SUNDAY,
    ScheduleWeekday.MONDAY,
    ScheduleWeekday.TUESDAY,
    ScheduleWeekday.WEDNESDAY,
    ScheduleWeekday.THURSDAY,
    ScheduleWeekday.FRIDAY,
    ScheduleWeekday.SATURDAY,
];

const workDays = computed(() => {
    return weekdays.filter((day: ScheduleWeekday) => props.modelValue[day]);
});

const formatDayLabel = (day: ScheduleWeekday) => t('schedule.labels.' + day.toLocaleLowerCase());
const emit = __emit;
const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

return (_ctx: any,_cache: any) => {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_WORK_SCHEDULE) ? 'RouterLink' : 'span'), {
            to: {
                        name: 'ViewWorkScheduleById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    },
            class: "text-md text-primary truncate font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.modelValue.name), 1)
            ]),
            _: 1
          }, 8, ["to"])),
          _createVNode(_component_UiIsActiveBadge, {
            "model-value": __props.modelValue,
            class: "ml-2 text-xs"
          }, null, 8, ["model-value"])
        ]),
        (_ctx.$can(_unref(Permission).EDIT_WORK_SCHEDULE))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (__props.modelValue.isActive)
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "danger",
                    onClick: handleInactivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('core.actions.Inactivate')), 1),
                      _createVNode(_unref(XCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Inactivate')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 1,
                    variant: "success",
                    onClick: handleActivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('core.actions.Activate')), 1),
                      _createVNode(_unref(CheckCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Activate')]
                  ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                class: "rounded-full",
                to: {
                        name: 'EditWorkScheduleById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createVNode(_unref(ClockIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(props.modelValue.timeBegin.substring(0, 5)) + " " + _toDisplayString(props.modelValue.timeEnd.substring(0, 5)), 1)
          ]),
          _createElementVNode("p", _hoisted_10, [
            _createVNode(_unref(CalendarIcon), {
              class: "h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workDays.value, (day) => {
              return (_openBlock(), _createElementBlock("span", {
                key: day,
                class: "whitespace-nowrap rounded border bg-white px-1.5 py-0.5 text-xs text-gray-500"
              }, _toDisplayString(formatDayLabel(day)), 1))
            }), 128))
          ])
        ]),
        _createVNode(UiAuditInfo, { "model-value": __props.modelValue }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})